import { NotificationSettingRes } from '../api/endpoints/profile/types/index'
import { profileTabs } from '../constants/misc'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import appApi from 'api'
import { ProfileFeature, SetPassword } from './types'
import { typeOfModal } from 'pages/profile/types'

const activeTabValue = localStorage.getItem('activeTabValue')

type InitProfileState = {
  feature: ProfileFeature,
  getNotificationSetting: NotificationSettingRes,
}

type Payload = {
  type: typeOfModal,
  isOpen: boolean,
  size?: 'sm' | 'md' | 'lg',
}

const initialState: InitProfileState = {
  feature: {
    tabs: {
      activeTabValue: activeTabValue
        ? parseInt(activeTabValue)
        : profileTabs[0].index,
    },
    modal: {
      isOpen: false,
      type: '',
      isEmailChecked: false,
    },
    textField: {
      isConfirmPasswordVisible: false,
      isCurrentPasswordVisible: false,
      isNewPasswordVisible: false,
      passwordValues: null,
    },
    currentErrorMessage: null,
    currentSuccessMessage: null,
  },
  getNotificationSetting: {
    userId: '',
    otp: {
      sms: false,
      email: false,
      totp: false,
    },
    notifications: {
      sms: false,
      email: false,
    },
  },
}

const profileSlice = createSlice({
  name: 'profileReducer',
  initialState,
  reducers: {
    setActiveTabValue(state, action: PayloadAction<number>) {
      state.feature.tabs.activeTabValue = action.payload
      state.feature.currentErrorMessage = null
      state.feature.currentSuccessMessage = null
      localStorage.setItem('activeTabValue', action.payload.toString())
    },
    setCustomModalOpen(state, action: PayloadAction<Payload>) {
      state.feature.modal = action.payload
      state.feature.currentErrorMessage = null
      state.feature.currentSuccessMessage = null
    },
    setCloseModal(state) {
      state.feature.modal.isOpen = false
    },
    setShowCurrentPassword(state, action: PayloadAction<boolean>) {
      state.feature.textField.isCurrentPasswordVisible = action.payload
    },
    setShowNewPassword(state, action: PayloadAction<boolean>) {
      state.feature.textField.isNewPasswordVisible = action.payload
    },
    setShowConfirmPassword(state, action: PayloadAction<boolean>) {
      state.feature.textField.isConfirmPasswordVisible = action.payload
    },
    resetProfileState(state) {
      state.feature = initialState.feature
    },
    setCurrentErrorMessage(state, action: PayloadAction<string | null>) {
      state.feature.currentSuccessMessage = null
      state.feature.currentErrorMessage = action.payload
    },
    setCurrentSuccessMessage(state, action: PayloadAction<string | null>) {
      state.feature.currentErrorMessage = null
      state.feature.currentSuccessMessage = action.payload
    },
    setPassword(state, action: PayloadAction<SetPassword | null>) {
      state.feature.textField.passwordValues = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        appApi.endpoints.getNotificationSetting.matchFulfilled,
        (state, { payload }) => {
          state.getNotificationSetting = payload
        }
      )
      .addMatcher(
        appApi.endpoints.updateNotificationSetting.matchRejected,
        (state, { payload }: any) => {
          state.feature.currentErrorMessage =
            payload.data.message || JSON.stringify(payload)
        }
      )
      .addMatcher(
        appApi.endpoints.sendOtp.matchRejected,
        (state, { payload }) => {
          state.feature.currentErrorMessage = JSON.stringify(payload)
        }
      )
      .addMatcher(
        appApi.endpoints.updatePassword.matchRejected,
        (state, { payload }: any) => {
          const { message } = payload.data
          state.feature.currentErrorMessage = message || JSON.stringify(payload)
        }
      )
  },
})

export const {
  setActiveTabValue,
  setCustomModalOpen,
  setShowConfirmPassword,
  setShowCurrentPassword,
  setShowNewPassword,
  setCloseModal,
  resetProfileState,
  setCurrentErrorMessage,
  setCurrentSuccessMessage,
  setPassword,
} = profileSlice.actions

export default profileSlice.reducer
